'use client';
import type { User } from 'firebase/auth';
import { useRouter } from 'next/navigation';
import React, { useEffect } from 'react';

import { CenteringLoadingCircle } from '~/components/common/CenteringLoadingCircle';

type Props = {
  user?: User;
  loading: boolean;
  children: React.ReactNode;
};

// ログイン必須ページにコンテナとして配置
// 未ログインの場合はログインページに遷移する
// ログイン必須ページに遷移する前にはボトムシートログインを促す
export const LoggedIn: React.FC<Props> = (props: Props) => {
  const { user, loading } = props;
  const router = useRouter();

  useEffect(() => {
    if (!loading && (user?.isAnonymous || user == undefined)) {
      const redirect_url =
        typeof window == 'undefined' ? null : window.location.pathname;
      const return_url = encodeURIComponent(redirect_url || '/e');

      router.replace(`/login?return_url=${return_url}`);
    }
  }, [user, loading]);

  if (loading) return <CenteringLoadingCircle />;
  return <>{props.children}</>;
};
